import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@material-ui/core/Button/index";
import { makeStyles } from "@material-ui/core/styles/index";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
});

export default function QrView({ show, onHide, base64 }) {
    const classes = useStyles();

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = base64;
        link.download = "1x2_fa_qr_code.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>QR Code</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classes.container}>
                    <img src={base64} alt="QR Code" />
                    <Button variant="contained" color="primary" onClick={handleDownload}>Yüklə</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}